import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    seo: {
      title: "L'Eskale Guyane — Appart-Hôtel 3★ à Rémire-Montjoly",
      description:
        "Réservation directe d'appartements meublés haut de gamme à Rémire-Montjoly, Guyane. Meilleur tarif garanti, conditions flexibles, conciergerie VIP.",
    },
    nav: {
      links: [
        { href: "#piliers", label: "Concept" },
        { href: "#logements", label: "Logements" },
        { href: "#direct", label: "Réservation" },
        { href: "#services", label: "Services" },
        { href: "#infos", label: "Infos pratiques" },
      ],
      book: "Réserver",
    },
    hero: {
      eyebrow: "Appart-Hôtel 3★ · Rémire-Montjoly · Guyane Française",
      tagline: "Votre ancrage d'exception à Rémire-Montjoly",
      cta: "Réserver directement — Meilleur Tarif Garanti",
      tripadvisor: "N°1 Résidences Rémire — TripAdvisor",
    },
    pillars: {
      eyebrow: "Notre promesse",
      title: "Trois piliers, une expérience",
      items: [
        { n: "01", title: "Désirabilité", text: "Un cadre de vie tropical, pas une chambre d'hôtel standard." },
        { n: "02", title: "Transparence", text: "Tarifs clairs, conditions lisibles, aucune mauvaise surprise." },
        { n: "03", title: "Fluidité", text: "Du premier clic à la remise des clés, en moins de 3 minutes." },
      ],
    },
    units: {
      T1: "T1 — Chambre Confort",
      T2: "T2 — Appartement Duplex",
      T3: "T3 — Appartement Duplex",
      VILLA: "Villa T4 — Villa Privée",
    },
    acc: {
      eyebrow: "Nos logements",
      title: "Quatre formats, une exigence",
      badge: "Best Seller",
      from: "À partir de",
      perNight: "/ nuit",
      breakfast: "Petit-déjeuner en option : 15 € / personne",
      pers: "pers.",
      book: "Réserver ce logement",
      conditions:
        "Conditions : annulation gratuite jusqu'à 48 h avant l'arrivée. Tarifs préférentiels pour longs séjours et entreprises — contactez-nous sur WhatsApp.",
      cards: {
        T1: {
          tagline: "Cocon optimisé pour 1–2 voyageurs",
          highlight: "Court ou moyen séjour",
          amenities: ["Réfrigérateur", "Machine à café", "Vue piscine", "Douche italienne", "TV satellite", "Climatisation", "Wi-Fi fibre"],
        },
        T2: {
          tagline: "Notre best-seller, parfait pour séjours moyens",
          highlight: "Tarif dégressif selon la durée",
          amenities: ["Lave-linge / sèche-linge", "Balcon privatif", "Kitchenette complète", "Dressing", "Canapé-lit", "Climatisation", "Wi-Fi fibre"],
        },
        T3: {
          tagline: "Espace généreux pour 4 personnes ou famille",
          highlight: "Idéal famille ou colocation pro",
          amenities: ["3 lits", "Four", "Entrée indépendante", "Terrasse", "Kitchenette complète", "Climatisation", "Wi-Fi fibre"],
        },
        VILLA: {
          tagline: "Villa indépendante jusqu'à 6 personnes",
          highlight: "Privatisation totale",
          amenities: ["Villa privée indépendante", "Accès équipements communs", "Piscine", "Salle de sport", "Parking sécurisé"],
        },
      },
    },
    reviews: {
      eyebrow: "Booking.com",
      title: "L'avis de nos clients",
      figureLabel: "avis notés « Bien » ou « Fabuleux »",
      source: "Source : Booking.com",
      personnel: "Personnel",
      situation: "Situation géographique",
      quotes: [
        { name: "Christian, France", score: "8/10", text: "Logement agréable et bien situé" },
        { name: "Emilie, France", score: "7/10", text: "Le personnel très agréable, intérieur propre, pratique, tout est bien pensé." },
      ],
      sourceNote: "Notes et avis issus de Booking.com — août 2026",
      cta: "Réserver en direct",
    },
    direct: {
      eyebrow: "Pourquoi réserver en direct",
      title: "L'avantage est ici",
      colAdvantage: "Avantage",
      colDirect: "Réservation directe",
      colOta: "Booking / Airbnb",
      rows: [
        ["Meilleur Tarif Garanti", "✓ Inclus", "✗ Commissions élevées"],
        ["Conditions d'annulation", "Ultra-flexibles", "Standards et rigides"],
        ["Service client", "Ligne VIP directe", "Support standard"],
        ["Avantages exclusifs", "Early check-in offert", "Aucun"],
      ],
    },
    services: {
      eyebrow: "Services & équipements",
      title: "L'exigence dans le détail",
      items: [
        { n: "01", title: "Connectivité Fibre", desc: "Indispensable pour nomades digitaux et cadres en mission." },
        { n: "02", title: "Climatisation intelligente", desc: "Confort thermique absolu, jour et nuit." },
        { n: "03", title: "Salle de sport", desc: "Maintenir sa routine même en déplacement." },
        { n: "04", title: "Conciergerie digitale", desc: "Disponible 7j/7 via WhatsApp." },
        { n: "05", title: "Parking sécurisé gratuit", desc: "Intérieur et extérieur, vidéosurveillé." },
        { n: "06", title: "Piscine 12m & aquabike", desc: "L'évasion à domicile, à toute heure." },
        { n: "07", title: "Massage & bien-être", desc: "Corporel, crânien, dos, pieds — sur rendez-vous." },
        { n: "08", title: "Accueil multilingue", desc: "Français, anglais, portugais." },
      ],
    },
    equip: {
      eyebrow: "Nos espaces",
      title: "La résidence en images",
      captions: {
        pool: "Piscine 12 m",
        gym: "Salle de sport",
        entrance: "Entrée & accueil",
        lounge: "Espace détente",
        parking: "Parking sécurisé",
      },
    },
    testimonial: {
      text: "Un niveau de prestation rare en Guyane. Le confort des appartements est digne des meilleurs boutique-hôtels de métropole. L'accueil et le service conciergerie font toute la différence.",
      author: "Marc D. · Voyageur Affaires Premium",
    },
    upsells: {
      eyebrow: "Upsell",
      title: "Complétez votre séjour",
      items: [
        { title: "Petit-déjeuner / Brunch local", price: "15 € / personne · en option", desc: "Produits frais, fruits tropicaux, douceurs créoles." },
        { title: "Panier blanchisserie", price: "Pressing 8 kg", desc: "Lavé, séché, plié — déposé devant votre porte." },
        { title: "Départ tardif", price: "Jusqu'à 16 h", desc: "Profitez de votre dernière journée sans précipitation." },
      ],
      cta: "Ajouter à ma réservation",
    },
    longstay: {
      eyebrow: "Entreprises & missions longues",
      title: "Longs séjours, conditions dédiées",
      text: "Vous préparez une mission longue durée, un chantier ou un déplacement d'équipe en Guyane ? Nous proposons des tarifs préférentiels pour les longs séjours et les entreprises, avec un interlocuteur unique du devis à la remise des clés.",
      cta: "Demander un devis sur WhatsApp",
      waMessage: "Bonjour, je souhaite obtenir un devis pour un long séjour ou une mission entreprise à L'Eskale Guyane.",
    },
    practical: {
      eyebrow: "Infos pratiques",
      title: "Tout ce qu'il faut savoir",
      items: [
        ["Check-in", "À partir de 11 h"],
        ["Check-out", "7 h – 11 h (départ tardif jusqu'à 16 h : +30 €)"],
        ["Âge minimum", "12 ans"],
        ["Animaux", "Acceptés sur demande — 15 € / jour"],
        ["Paiement", "Carte bancaire uniquement"],
        ["Dépôt de garantie", "400 €"],
        ["Taxe de séjour", "1,50 € / pers. / nuit"],
        ["Règles de la maison", "Silence 20 h – 8 h · fêtes interdites"],
      ],
    },
    finalCta: {
      title: "Réserver l'Exception",
      text: "Une expérience fluide, du premier clic à la remise des clés.",
      cta: "Démarrer la réservation",
    },
    footer: {
      contact: "Contact",
      legal: "Légal",
      booking: "Disponible sur Booking.com — programme Genius",
      mentions: "Mentions légales",
      privacy: "Politique de confidentialité",
      cookies: "Gestion des cookies",
      rights: "Tous droits réservés",
    },
    wa: {
      floating: "Réserver via WhatsApp",
      generic: "Bonjour je souhaite obtenir des informations concernant une réservation à L'Eskale Guyane",
      units: {
        T1: "Bonjour, je souhaite obtenir des informations concernant le T1 de L'Eskale Guyane.",
        T2: "Bonjour, je souhaite obtenir des informations concernant le T2 de L'Eskale Guyane.",
        T3: "Bonjour, je souhaite obtenir des informations concernant le T3 de L'Eskale Guyane.",
        VILLA: "Bonjour, je souhaite obtenir des informations concernant la Villa de L'Eskale Guyane.",
      },
    },
    modal: {
      header: "Réservation directe",
      step: "Étape",
      s1title: "Choisissez votre logement",
      s1sub: "Quatre formats, une exigence.",
      priceHint: "Tarif indicatif",
      upTo: "jusqu'à",
      pers: "pers.",
      baseLabels: { T1: "à partir de 90€ / nuit", T2: "à partir de 120€ / nuit", T3: "à partir de 180€ / nuit", VILLA: "à partir de 350€ / nuit" },
      s2title: "Vos dates",
      s2sub: "Le tarif s'ajuste automatiquement selon la durée.",
      arrival: "Arrivée",
      departure: "Départ",
      nightsLabel: "Nuits",
      rateLabel: "Tarif applicable",
      perNight: "€ / nuit",
      s3title: "Voyageurs",
      s3sub: (cap) => `Capacité de base : ${cap} pers. Au-delà : +25 € / nuit / personne.`,
      adults: "adultes",
      extraNote: (n, cost) => `+ ${n} pers. · supplément ${cost} €`,
      s4title: "Compléments",
      s4sub: "Optionnels, ajustables au check-in.",
      upsellLabels: {
        brunch: "Petit-déjeuner / Brunch local (par pers.)",
        laundry: "Panier blanchisserie 8 kg",
        latecheckout: "Départ tardif jusqu'à 16 h",
      },
      s5title: "Récapitulatif",
      unit: "Logement",
      stay: "Séjour",
      nightsWord: "nuit(s)",
      travelers: "Voyageurs",
      lodging: (nightly, nights) => `Hébergement (${nightly}€ × ${nights})`,
      extraPersons: "Personnes supplémentaires",
      extras: "Compléments",
      tax: "Taxe de séjour (1,50 €/pers./nuit)",
      total: "Total estimé",
      firstname: "Prénom",
      lastname: "Nom",
      email: "Email",
      phone: "Téléphone",
      message: "Message (optionnel)",
      submit: "Confirmer et envoyer",
      note: "Aucun paiement en ligne — confirmation et règlement par carte au check-in. Dépôt de garantie 400 €.",
      sentTitle: "Demande envoyée",
      sentSub: "Notre conciergerie vous répond sous quelques heures. Vous pouvez fermer cette fenêtre.",
      close: "Fermer",
      back: "← Retour",
      next: "Continuer →",
      finalStep: "Étape finale",
      waIntro: "Bonjour, demande de réservation L'Eskale Guyane",
      waUnit: "Logement",
      waDates: (a, d, n) => `Du ${a} au ${d} (${n} nuit${n > 1 ? "s" : ""})`,
      waTravelers: "Voyageurs",
      waOptions: "Options",
      waNone: "aucune",
      waTotal: "Total estimé",
      errors: { prenom: "Prénom requis", nom: "Nom requis", email: "Email invalide", telephone: "Téléphone requis" },
    },
  },
  en: {
    seo: {
      title: "L'Eskale Guyane — 3★ Aparthotel in Rémire-Montjoly, French Guiana",
      description:
        "Book direct: premium furnished apartments in Rémire-Montjoly, French Guiana. Best rate guaranteed, flexible conditions, VIP concierge.",
    },
    nav: {
      links: [
        { href: "#piliers", label: "Concept" },
        { href: "#logements", label: "Accommodation" },
        { href: "#direct", label: "Booking" },
        { href: "#services", label: "Services" },
        { href: "#infos", label: "Practical info" },
      ],
      book: "Book now",
    },
    hero: {
      eyebrow: "3★ Aparthotel · Rémire-Montjoly · French Guiana",
      tagline: "Your exceptional home base in Rémire-Montjoly",
      cta: "Book direct — Best Rate Guaranteed",
      tripadvisor: "No.1 Residences in Rémire — TripAdvisor",
    },
    pillars: {
      eyebrow: "Our promise",
      title: "Three pillars, one experience",
      items: [
        { n: "01", title: "Desirability", text: "A tropical living environment, not a standard hotel room." },
        { n: "02", title: "Transparency", text: "Clear rates, readable conditions, no bad surprises." },
        { n: "03", title: "Simplicity", text: "From the first click to key handover in under 3 minutes." },
      ],
    },
    units: {
      T1: "T1 — Comfort Room",
      T2: "T2 — Duplex Apartment",
      T3: "T3 — Duplex Apartment",
      VILLA: "Villa T4 — Private Villa",
    },
    acc: {
      eyebrow: "Our accommodation",
      title: "Four formats, one standard",
      badge: "Best Seller",
      from: "From",
      perNight: "/ night",
      breakfast: "Optional breakfast: €15 / person",
      pers: "guests",
      book: "Book this accommodation",
      conditions:
        "Conditions: free cancellation up to 48 hours before arrival. Preferential rates for long stays and companies — contact us on WhatsApp.",
      cards: {
        T1: {
          tagline: "A cosy nest optimised for 1–2 travellers",
          highlight: "Short or medium stay",
          amenities: ["Fridge", "Coffee machine", "Pool view", "Walk-in shower", "Satellite TV", "Air conditioning", "Fibre Wi-Fi"],
        },
        T2: {
          tagline: "Our best-seller, perfect for medium stays",
          highlight: "Decreasing rate by length of stay",
          amenities: ["Washer / dryer", "Private balcony", "Full kitchenette", "Walk-in closet", "Sofa bed", "Air conditioning", "Fibre Wi-Fi"],
        },
        T3: {
          tagline: "Generous space for 4 guests or a family",
          highlight: "Ideal for families or work teams",
          amenities: ["3 beds", "Oven", "Independent entrance", "Terrace", "Full kitchenette", "Air conditioning", "Fibre Wi-Fi"],
        },
        VILLA: {
          tagline: "Independent villa for up to 6 guests",
          highlight: "Fully private",
          amenities: ["Independent private villa", "Access to shared facilities", "Swimming pool", "Fitness room", "Secure parking"],
        },
      },
    },
    reviews: {
      eyebrow: "Booking.com",
      title: "What our guests say",
      figureLabel: "reviews rated “Good” or “Fabulous”",
      source: "Source: Booking.com",
      personnel: "Staff",
      situation: "Location",
      quotes: [
        { name: "Christian, France", score: "8/10", text: "Logement agréable et bien situé" },
        { name: "Emilie, France", score: "7/10", text: "Le personnel très agréable, intérieur propre, pratique, tout est bien pensé." },
      ],
      sourceNote: "Scores and reviews from Booking.com — August 2026",
      cta: "Book direct",
    },
    direct: {
      eyebrow: "Why book direct",
      title: "The advantage is here",
      colAdvantage: "Advantage",
      colDirect: "Direct booking",
      colOta: "Booking / Airbnb",
      rows: [
        ["Best Rate Guaranteed", "✓ Included", "✗ High commissions"],
        ["Cancellation policy", "Ultra-flexible", "Standard and rigid"],
        ["Customer service", "Direct VIP line", "Standard support"],
        ["Exclusive perks", "Free early check-in", "None"],
      ],
    },
    services: {
      eyebrow: "Services & facilities",
      title: "Excellence in every detail",
      items: [
        { n: "01", title: "Fibre connectivity", desc: "Essential for digital nomads and executives on assignment." },
        { n: "02", title: "Smart air conditioning", desc: "Absolute thermal comfort, day and night." },
        { n: "03", title: "Fitness room", desc: "Keep your routine even while travelling." },
        { n: "04", title: "Digital concierge", desc: "Available 7 days a week via WhatsApp." },
        { n: "05", title: "Free secure parking", desc: "Indoor and outdoor, video-monitored." },
        { n: "06", title: "12m pool & aquabike", desc: "An escape at home, at any hour." },
        { n: "07", title: "Massage & wellness", desc: "Body, head, back, feet — by appointment." },
        { n: "08", title: "Multilingual welcome", desc: "French, English, Portuguese." },
      ],
    },
    equip: {
      eyebrow: "Our spaces",
      title: "The residence in pictures",
      captions: {
        pool: "12 m swimming pool",
        gym: "Fitness room",
        entrance: "Entrance & reception",
        lounge: "Lounge area",
        parking: "Secure parking",
      },
    },
    testimonial: {
      text: "A rare level of service in French Guiana. The comfort of the apartments is worthy of the best boutique hotels in mainland France. The welcome and concierge service make all the difference.",
      author: "Marc D. · Premium Business Traveller",
    },
    upsells: {
      eyebrow: "Extras",
      title: "Complete your stay",
      items: [
        { title: "Breakfast / Local brunch", price: "€15 / person · optional", desc: "Fresh produce, tropical fruits, Creole delicacies." },
        { title: "Laundry basket", price: "8 kg pressing", desc: "Washed, dried, folded — delivered to your door." },
        { title: "Late check-out", price: "Until 4 pm", desc: "Enjoy your last day without rushing." },
      ],
      cta: "Add to my booking",
    },
    longstay: {
      eyebrow: "Companies & long assignments",
      title: "Long stays, dedicated terms",
      text: "Planning a long-term assignment, a worksite or a team trip to French Guiana? We offer preferential rates for long stays and companies, with a single point of contact from quote to key handover.",
      cta: "Request a quote on WhatsApp",
      waMessage: "Hello, I would like a quote for a long stay or a corporate assignment at L'Eskale Guyane.",
    },
    practical: {
      eyebrow: "Practical info",
      title: "Everything you need to know",
      items: [
        ["Check-in", "From 11 am"],
        ["Check-out", "7 am – 11 am (late check-out until 4 pm: +€30)"],
        ["Minimum age", "12 years"],
        ["Pets", "Accepted on request — €15 / day"],
        ["Payment", "Bank card only"],
        ["Security deposit", "€400"],
        ["Tourist tax", "€1.50 / person / night"],
        ["House rules", "Quiet hours 8 pm – 8 am · no parties"],
      ],
    },
    finalCta: {
      title: "Book the Exception",
      text: "A seamless experience, from the first click to key handover.",
      cta: "Start booking",
    },
    footer: {
      contact: "Contact",
      legal: "Legal",
      booking: "Available on Booking.com — Genius programme",
      mentions: "Legal notice",
      privacy: "Privacy policy",
      cookies: "Cookie settings",
      rights: "All rights reserved",
    },
    wa: {
      floating: "Book via WhatsApp",
      generic: "Hello, I would like information about a booking at L'Eskale Guyane",
      units: {
        T1: "Hello, I would like information about the T1 at L'Eskale Guyane.",
        T2: "Hello, I would like information about the T2 at L'Eskale Guyane.",
        T3: "Hello, I would like information about the T3 at L'Eskale Guyane.",
        VILLA: "Hello, I would like information about the Villa at L'Eskale Guyane.",
      },
    },
    modal: {
      header: "Direct booking",
      step: "Step",
      s1title: "Choose your accommodation",
      s1sub: "Four formats, one standard.",
      priceHint: "Indicative rate",
      upTo: "up to",
      pers: "guests",
      baseLabels: { T1: "from €90 / night", T2: "from €120 / night", T3: "from €180 / night", VILLA: "from €350 / night" },
      s2title: "Your dates",
      s2sub: "The rate adjusts automatically to the length of stay.",
      arrival: "Arrival",
      departure: "Departure",
      nightsLabel: "Nights",
      rateLabel: "Applicable rate",
      perNight: "€ / night",
      s3title: "Guests",
      s3sub: (cap) => `Base capacity: ${cap} guests. Beyond: +€25 / night / person.`,
      adults: "adults",
      extraNote: (n, cost) => `+ ${n} guest(s) · surcharge €${cost}`,
      s4title: "Extras",
      s4sub: "Optional, adjustable at check-in.",
      upsellLabels: {
        brunch: "Breakfast / Local brunch (per pers.)",
        laundry: "8 kg laundry basket",
        latecheckout: "Late check-out until 4 pm",
      },
      s5title: "Summary",
      unit: "Accommodation",
      stay: "Stay",
      nightsWord: "night(s)",
      travelers: "Guests",
      lodging: (nightly, nights) => `Accommodation (€${nightly} × ${nights})`,
      extraPersons: "Extra guests",
      extras: "Extras",
      tax: "Tourist tax (€1.50/pers./night)",
      total: "Estimated total",
      firstname: "First name",
      lastname: "Last name",
      email: "Email",
      phone: "Phone",
      message: "Message (optional)",
      submit: "Confirm and send",
      note: "No online payment — confirmation and card payment at check-in. €400 security deposit.",
      sentTitle: "Request sent",
      sentSub: "Our concierge team will reply within a few hours. You can close this window.",
      close: "Close",
      back: "← Back",
      next: "Continue →",
      finalStep: "Final step",
      waIntro: "Hello, booking request for L'Eskale Guyane",
      waUnit: "Accommodation",
      waDates: (a, d, n) => `From ${a} to ${d} (${n} night${n > 1 ? "s" : ""})`,
      waTravelers: "Guests",
      waOptions: "Extras",
      waNone: "none",
      waTotal: "Estimated total",
      errors: { prenom: "First name required", nom: "Last name required", email: "Invalid email", telephone: "Phone required" },
    },
  },
  pt: {
    seo: {
      title: "L'Eskale Guyane — Apart-Hotel 3★ em Rémire-Montjoly, Guiana Francesa",
      description:
        "Reserve direto: apartamentos mobiliados premium em Rémire-Montjoly, Guiana Francesa. Melhor tarifa garantida, condições flexíveis, concierge VIP.",
    },
    nav: {
      links: [
        { href: "#piliers", label: "Conceito" },
        { href: "#logements", label: "Acomodações" },
        { href: "#direct", label: "Reservas" },
        { href: "#services", label: "Serviços" },
        { href: "#infos", label: "Informações" },
      ],
      book: "Reservar",
    },
    hero: {
      eyebrow: "Apart-Hotel 3★ · Rémire-Montjoly · Guiana Francesa",
      tagline: "Seu refúgio de exceção em Rémire-Montjoly",
      cta: "Reserve direto — Melhor Tarifa Garantida",
      tripadvisor: "Nº1 Residências em Rémire — TripAdvisor",
    },
    pillars: {
      eyebrow: "Nossa promessa",
      title: "Três pilares, uma experiência",
      items: [
        { n: "01", title: "Desejabilidade", text: "Um ambiente de vida tropical, não um quarto de hotel padrão." },
        { n: "02", title: "Transparência", text: "Tarifas claras, condições legíveis, nenhuma surpresa desagradável." },
        { n: "03", title: "Fluidez", text: "Do primeiro clique à entrega das chaves em menos de 3 minutos." },
      ],
    },
    units: {
      T1: "T1 — Quarto Conforto",
      T2: "T2 — Apartamento Duplex",
      T3: "T3 — Apartamento Duplex",
      VILLA: "Villa T4 — Villa Privativa",
    },
    acc: {
      eyebrow: "Nossas acomodações",
      title: "Quatro formatos, um padrão",
      badge: "Best Seller",
      from: "A partir de",
      perNight: "/ noite",
      breakfast: "Café da manhã opcional: 15 € / pessoa",
      pers: "pessoas",
      book: "Reservar esta acomodação",
      conditions:
        "Condições: cancelamento gratuito até 48 h antes da chegada. Tarifas preferenciais para estadias longas e empresas — fale conosco no WhatsApp.",
      cards: {
        T1: {
          tagline: "Refúgio otimizado para 1–2 viajantes",
          highlight: "Estadia curta ou média",
          amenities: ["Geladeira", "Máquina de café", "Vista para a piscina", "Ducha italiana", "TV via satélite", "Ar-condicionado", "Wi-Fi fibra"],
        },
        T2: {
          tagline: "Nosso best-seller, perfeito para estadias médias",
          highlight: "Tarifa decrescente conforme a duração",
          amenities: ["Lavadora / secadora", "Varanda privativa", "Cozinha compacta completa", "Closet", "Sofá-cama", "Ar-condicionado", "Wi-Fi fibra"],
        },
        T3: {
          tagline: "Espaço generoso para 4 pessoas ou família",
          highlight: "Ideal para famílias ou equipes de trabalho",
          amenities: ["3 camas", "Forno", "Entrada independente", "Terraço", "Cozinha compacta completa", "Ar-condicionado", "Wi-Fi fibra"],
        },
        VILLA: {
          tagline: "Villa independente para até 6 pessoas",
          highlight: "Privatização total",
          amenities: ["Villa privativa independente", "Acesso às áreas comuns", "Piscina", "Academia", "Estacionamento seguro"],
        },
      },
    },
    reviews: {
      eyebrow: "Booking.com",
      title: "A opinião dos nossos hóspedes",
      figureLabel: "avaliações classificadas como “Bom” ou “Fabuloso”",
      source: "Fonte: Booking.com",
      personnel: "Equipe",
      situation: "Localização",
      quotes: [
        { name: "Christian, France", score: "8/10", text: "Logement agréable et bien situé" },
        { name: "Emilie, France", score: "7/10", text: "Le personnel très agréable, intérieur propre, pratique, tout est bien pensé." },
      ],
      sourceNote: "Notas e avaliações do Booking.com — agosto de 2026",
      cta: "Reserve direto",
    },
    direct: {
      eyebrow: "Por que reservar direto",
      title: "A vantagem está aqui",
      colAdvantage: "Vantagem",
      colDirect: "Reserva direta",
      colOta: "Booking / Airbnb",
      rows: [
        ["Melhor Tarifa Garantida", "✓ Incluída", "✗ Comissões elevadas"],
        ["Política de cancelamento", "Ultra flexível", "Padrão e rígida"],
        ["Atendimento ao cliente", "Linha VIP direta", "Suporte padrão"],
        ["Vantagens exclusivas", "Early check-in grátis", "Nenhuma"],
      ],
    },
    services: {
      eyebrow: "Serviços e comodidades",
      title: "Exigência em cada detalhe",
      items: [
        { n: "01", title: "Conectividade fibra", desc: "Indispensável para nômades digitais e executivos em missão." },
        { n: "02", title: "Ar-condicionado inteligente", desc: "Conforto térmico absoluto, dia e noite." },
        { n: "03", title: "Academia", desc: "Mantenha sua rotina mesmo em viagem." },
        { n: "04", title: "Concierge digital", desc: "Disponível 7 dias por semana via WhatsApp." },
        { n: "05", title: "Estacionamento seguro gratuito", desc: "Interno e externo, com videomonitoramento." },
        { n: "06", title: "Piscina 12m & aquabike", desc: "Uma fuga em casa, a qualquer hora." },
        { n: "07", title: "Massagem & bem-estar", desc: "Corporal, craniana, costas, pés — com hora marcada." },
        { n: "08", title: "Recepção multilíngue", desc: "Francês, inglês, português." },
      ],
    },
    equip: {
      eyebrow: "Nossos espaços",
      title: "A residência em imagens",
      captions: {
        pool: "Piscina de 12 m",
        gym: "Academia",
        entrance: "Entrada e recepção",
        lounge: "Espaço lounge",
        parking: "Estacionamento seguro",
      },
    },
    testimonial: {
      text: "Um nível de serviço raro na Guiana Francesa. O conforto dos apartamentos é digno dos melhores hotéis-butique da França metropolitana. A recepção e o serviço de concierge fazem toda a diferença.",
      author: "Marc D. · Viajante de Negócios Premium",
    },
    upsells: {
      eyebrow: "Extras",
      title: "Complete sua estadia",
      items: [
        { title: "Café da manhã / Brunch local", price: "15 € / pessoa · opcional", desc: "Produtos frescos, frutas tropicais, delícias crioulas." },
        { title: "Cesta de lavanderia", price: "8 kg de roupa", desc: "Lavada, seca, dobrada — entregue na sua porta." },
        { title: "Late check-out", price: "Até 16 h", desc: "Aproveite seu último dia sem pressa." },
      ],
      cta: "Adicionar à minha reserva",
    },
    longstay: {
      eyebrow: "Empresas e missões longas",
      title: "Estadias longas, condições dedicadas",
      text: "Está planejando uma missão de longa duração, uma obra ou uma viagem de equipe à Guiana Francesa? Oferecemos tarifas preferenciais para estadias longas e empresas, com um único ponto de contato do orçamento à entrega das chaves.",
      cta: "Solicitar orçamento no WhatsApp",
      waMessage: "Olá, gostaria de um orçamento para uma estadia longa ou uma missão corporativa no L'Eskale Guyane.",
    },
    practical: {
      eyebrow: "Informações práticas",
      title: "Tudo o que você precisa saber",
      items: [
        ["Check-in", "A partir das 11 h"],
        ["Check-out", "7 h – 11 h (late check-out até 16 h: +30 €)"],
        ["Idade mínima", "12 anos"],
        ["Animais", "Aceitos sob consulta — 15 € / dia"],
        ["Pagamento", "Somente cartão bancário"],
        ["Caução", "400 €"],
        ["Taxa de turismo", "1,50 € / pessoa / noite"],
        ["Regras da casa", "Silêncio 20 h – 8 h · festas proibidas"],
      ],
    },
    finalCta: {
      title: "Reserve a Exceção",
      text: "Uma experiência fluida, do primeiro clique à entrega das chaves.",
      cta: "Iniciar reserva",
    },
    footer: {
      contact: "Contato",
      legal: "Legal",
      booking: "Disponível no Booking.com — programa Genius",
      mentions: "Menções legais",
      privacy: "Política de privacidade",
      cookies: "Gestão de cookies",
      rights: "Todos os direitos reservados",
    },
    wa: {
      floating: "Reservar via WhatsApp",
      generic: "Olá, gostaria de informações sobre uma reserva no L'Eskale Guyane",
      units: {
        T1: "Olá, gostaria de informações sobre o T1 do L'Eskale Guyane.",
        T2: "Olá, gostaria de informações sobre o T2 do L'Eskale Guyane.",
        T3: "Olá, gostaria de informações sobre o T3 do L'Eskale Guyane.",
        VILLA: "Olá, gostaria de informações sobre a Villa do L'Eskale Guyane.",
      },
    },
    modal: {
      header: "Reserva direta",
      step: "Etapa",
      s1title: "Escolha sua acomodação",
      s1sub: "Quatro formatos, um padrão.",
      priceHint: "Tarifa indicativa",
      upTo: "até",
      pers: "pessoas",
      baseLabels: { T1: "a partir de 90€ / noite", T2: "a partir de 120€ / noite", T3: "a partir de 180€ / noite", VILLA: "a partir de 350€ / noite" },
      s2title: "Suas datas",
      s2sub: "A tarifa se ajusta automaticamente à duração.",
      arrival: "Chegada",
      departure: "Saída",
      nightsLabel: "Noites",
      rateLabel: "Tarifa aplicável",
      perNight: "€ / noite",
      s3title: "Hóspedes",
      s3sub: (cap) => `Capacidade base: ${cap} pessoas. Acima disso: +25 € / noite / pessoa.`,
      adults: "adultos",
      extraNote: (n, cost) => `+ ${n} pessoa(s) · suplemento ${cost} €`,
      s4title: "Extras",
      s4sub: "Opcionais, ajustáveis no check-in.",
      upsellLabels: {
        brunch: "Café da manhã / Brunch local (por pessoa)",
        laundry: "Cesta de lavanderia 8 kg",
        latecheckout: "Late check-out até 16 h",
      },
      s5title: "Resumo",
      unit: "Acomodação",
      stay: "Estadia",
      nightsWord: "noite(s)",
      travelers: "Hóspedes",
      lodging: (nightly, nights) => `Hospedagem (${nightly}€ × ${nights})`,
      extraPersons: "Pessoas adicionais",
      extras: "Extras",
      tax: "Taxa de turismo (1,50 €/pessoa/noite)",
      total: "Total estimado",
      firstname: "Nome",
      lastname: "Sobrenome",
      email: "E-mail",
      phone: "Telefone",
      message: "Mensagem (opcional)",
      submit: "Confirmar e enviar",
      note: "Sem pagamento online — confirmação e pagamento com cartão no check-in. Caução de 400 €.",
      sentTitle: "Solicitação enviada",
      sentSub: "Nosso concierge responde em algumas horas. Você pode fechar esta janela.",
      close: "Fechar",
      back: "← Voltar",
      next: "Continuar →",
      finalStep: "Etapa final",
      waIntro: "Olá, solicitação de reserva L'Eskale Guyane",
      waUnit: "Acomodação",
      waDates: (a, d, n) => `De ${a} a ${d} (${n} noite${n > 1 ? "s" : ""})`,
      waTravelers: "Hóspedes",
      waOptions: "Extras",
      waNone: "nenhum",
      waTotal: "Total estimado",
      errors: { prenom: "Nome obrigatório", nom: "Sobrenome obrigatório", email: "E-mail inválido", telephone: "Telefone obrigatório" },
    },
  },
};

const LangContext = createContext(null);

export const SUPPORTED_LANGS = ["fr", "en", "pt"];

function getInitialLang() {
  const p = new URLSearchParams(window.location.search).get("lang");
  if (SUPPORTED_LANGS.includes(p)) return p;
  const saved = localStorage.getItem("eskale-lang");
  if (SUPPORTED_LANGS.includes(saved)) return saved;
  const browserLangs = navigator.languages || [navigator.language || ""];
  for (const bl of browserLangs) {
    const code = bl.slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGS.includes(code)) return code;
  }
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);
  const setLang = (l) => {
    if (!SUPPORTED_LANGS.includes(l)) return;
    setLangState(l);
    localStorage.setItem("eskale-lang", l);
    const url = new URL(window.location.href);
    if (l === "fr") url.searchParams.delete("lang");
    else url.searchParams.set("lang", l);
    window.history.replaceState({}, "", url);
  };
  return <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
